// editorTipsString mas tvar '4-1,7-2'
function parseEditorTips(editorTipsString) {
    if (!editorTipsString || editorTipsString === '' || typeof editorTipsString !== 'string') {
        return {};
    }

    return (
        editorTipsString
            .split(',')
            .filter(Boolean)
            //editortip ma tvar '4-1'
            .reduce((acc, editortip) => {
                const [betNumber, tip] = editortip.split('-');
                if (!betNumber || !tip) {
                    return acc;
                }

                if (!acc[betNumber]) {
                    acc[betNumber] = [];
                }

                acc[betNumber].push(tip);
                return acc;
            }, {})
    );
}

export default parseEditorTips;

// console.assert(JSON.stringify(parseEditorTips()) === JSON.stringify({}), "parseEditorTips()");
// console.assert(JSON.stringify(parseEditorTips(null)) === JSON.stringify({}), "parseEditorTips(null)");
// console.assert(JSON.stringify(parseEditorTips([])) === JSON.stringify({}), "parseEditorTips([])");
// console.assert(JSON.stringify(parseEditorTips('')) === JSON.stringify({}), "parseEditorTips('')");
// console.assert(JSON.stringify(parseEditorTips('4')) === JSON.stringify({}), "parseEditorTips('4')");
// console.assert(JSON.stringify(parseEditorTips('4-')) === JSON.stringify({}), "parseEditorTips('4-')");
// console.assert(JSON.stringify(parseEditorTips('4-1')) === JSON.stringify({4: ['1']}), "parseEditorTips('4-1')");
// console.assert(JSON.stringify(parseEditorTips('4-1,')) === JSON.stringify({4: ['1']}), "parseEditorTips('4-1,')");
// console.assert(JSON.stringify(parseEditorTips('4-1,7')) === JSON.stringify({4: ['1']}), "parseEditorTips('4-1,7')");
// console.assert(JSON.stringify(parseEditorTips('4-1,7-')) === JSON.stringify({4: ['1']}), "parseEditorTips('4-1,7-')");
// console.assert(JSON.stringify(parseEditorTips('4-1,7-2')) === JSON.stringify({4: ['1'], 7: ['2']}), "parseEditorTips('4-1,7-2')");
